(function () {
	'use strict';

    /*
     DisplayPageDetailsController
    -------------------------------------------------------------------------- */

	angular
		.module('PublicApp.page.details', [])
		.controller('DisplayPageDetailsController', [
			'$scope',
			'$state',
			'appServices',
			'__DataStore',
			DisplayPageDetailsController
		]);

    /**
      * DisplayPageDetailsController handle add pages form
      * @inject $scope
      * @inject $state
      * @inject appServices
      * @inject __DataStore
      * 
      * @return void
      *-------------------------------------------------------- */

	function DisplayPageDetailsController($scope, $state, appServices, __DataStore) {

		var scope = this,
			URL = {
				'apiURL': 'display.page.details',
				'pageID': $state.params.pageID
			};


		var activepages = __globals.getActivePagesData(),
			pages = __globals.findParents(activepages, $state.params.pageID),
			allPages = pages.reverse(),
			totalPages = allPages.length - 1;

		// get last page 
		_.forEach(pages, function (value, index) {

			if (index == totalPages) {
				scope.last_page = value.title;
			}
		});

		if (totalPages === 0) {

			// inject breadcrumb service
			appServices.updateBreadcrumbs([
				{
					items: '',
					last_item: scope.last_page
				}
			], $scope);

		} else {

			// initial function remove last index and return remaining indexes
			_.forEach(_.initial(allPages), function (value, index) {

				//inject breadcrumb service
				appServices.updateBreadcrumbs([
					{
						items: [{
							item: value.title,
							url: value.link
								? value.link
								: $state.href('display_page_details',
									{
										'pageID': value.key,
										'pageTitle': __globals.slug(value.title)
									})
						}],
						last_item: scope.last_page
					}
				], $scope);
			});
		}

		/**
		* get pages info
		* 
		* @return void
		*-------------------------------------------------------- */

		scope.getPageInfo = function () {

			__DataStore.fetch(URL, scope)
				.success(function (responseData) {

					appServices.processResponse(responseData, null, function () {

						var requestData = responseData.data;

						scope.pageDetails = requestData;
					});

				});
		};
		scope.getPageInfo();

	};

})();